import { createContext } from "react";
import PropTypes from "prop-types";
import logger from "@airhelp/node-logger";

const NO_SETTINGS_PROVIDER_MESSAGE = "Please wrap your component with `SettingsContextProvider`.";

export const SettingsContext = createContext({
  settings: () => logger.fatal(NO_SETTINGS_PROVIDER_MESSAGE),
});

export const SettingsContextProvider = ({ settings, children }) => (
  <SettingsContext.Provider value={{ ...settings }}>{children}</SettingsContext.Provider>
);

SettingsContextProvider.defaultProps = {
  settings: {},
};

SettingsContextProvider.propTypes = {
  settings: PropTypes.shape({}),
  children: PropTypes.node.isRequired,
};
